const ADDITIONAL_SEATS_SKUS_CS = ['TRAINING:1025', 'TRAINING:1027', 'TRAINING:1028', 'TRAINING:1029'] // level 1, 2
const ADDITIONAL_SEATS_SKUS_MG = [
  'TRAINING:2047',
  'TRAINING:2048',
  'TRAINING:1030',
  'TRAINING:1031',
  'TRAINING:2053',
  'TRAINING:2054'
] // level 1, 2, 3
const ADDITIONAL_SEATS_SKUS_TESTING = ['FAKESKU:2'] // test product

export const ADDITIONAL_SEATS_SKUS = [
  ...ADDITIONAL_SEATS_SKUS_CS,
  ...ADDITIONAL_SEATS_SKUS_MG,
  ...ADDITIONAL_SEATS_SKUS_TESTING
]
